import React from 'react';

import { Link } from 'react-router-dom';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import { useBasePath } from 'hooks/useBasePath';

import { usePhasePerformanceStore } from 'store/phasePerformance.store';

import NoData from 'components/common/NoData/noData';

import { portfolioConfig } from 'components/Dashboards/Portfolio/portfolioConfig';

export const PhasePerformanceNoData = () => {
    const basePath = useBasePath();
    const template = usePhasePerformanceStore((store) => store.template);
    const linkToManageTemplates = AppRoutes.buildPath(basePath, portfolioConfig.phasePerformanceManage.link);
    return !template ? (
        <NoData>
            No templates defined yet. Click <Link to={linkToManageTemplates}>Manage templates</Link> above to set it up.
        </NoData>
    ) : null;
};
